import { selectInputDataReducer } from 'Components/Forms/FormReducers/SelectInputReducer';
import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { radioInputDataReducer } from 'Components/Forms/FormReducers/RadioInputReducer';

import { useReducer, useRef } from "react";

var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};


export function GetTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var textInputObj = {
        type: 'text',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj);
}

export function GetSelectInputObj ({ id, name, value, prevValue, options, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var selectInputObj = {
        type: 'select',
        id: id,
        name: name,
        value: value,
        prevValue: prevValue,
        options: options,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isSelected==true){
                    return ans[x].value;
                }
            }
            return null;
        },
        getDisplayValue: (ans) => {
            console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isSelected==true){
                    return ans[x].displayValue;
                }
            }
            return null;
        }
    };

    return useReducer(selectInputDataReducer, selectInputObj);
}

export function GetRadioInputObj ({ id, name, value, prevValue, radioButtons, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, inline, defaultValue}) {
    var radioInputObj = {
        type: 'radioButtonGroup',
        id: id,
        name: name,
        value: value,
        prevValue: prevValue,
        defaultValue: defaultValue,
        radioButtons: radioButtons,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    return ans[x].value;
                }
            }
            return '';
        }
    };

    return useReducer(radioInputDataReducer, radioInputObj);
}

export function GetFilterTextInputData (fieldName, fieldValue) {
    switch (fieldName) {
        case 'search':
            return GetTextInputObj({
                id: fieldName,
                name: fieldName,
                value: fieldValue,
                label: 'Search articles',
                description: null,
                title: '',
                placeholder: 'Search articles...',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                maxLength: 100
            });
    }

}

export function GetFilterSelectInputData (fieldName, fieldValue) {
    switch (fieldName) {
       
        case 'topic':
            return GetSelectInputObj({
                id: fieldName,
                name: fieldName,
                value: fieldValue,
                prevValue: null,
                options: [],
                label: 'All Topics',
                description: '',
                title: '',
                placeholder: 'Select Topic',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                results: 0
            });
        case 'type':
            return GetSelectInputObj({
                id: fieldName,
                name: fieldName,
                value: fieldValue,
                prevValue: null,
                options: [],
                label: 'All Types',
                description: '',
                title: '',
                placeholder: 'Select Type',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'years':
            return GetSelectInputObj({
                id: fieldName,
                name: fieldName,
                value: fieldValue,
                prevValue: null,
                options: [],
                label: 'Years',
                description: '',
                title: '',
                placeholder: 'Select Years',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        
    }
}

export function GetFilterRadioInputData (fieldName, fieldValue) {
    switch (fieldName) {
        case "sortBy":
            return GetRadioInputObj({
                id: fieldName,
                name: fieldName,
                defaultValue: fieldValue,
                value: fieldValue,
                prevValue: null,
                radioButtons: [],
                label: 'Sort by',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: false,
                getValue: (ans) => {
                    //console.log(ans);
                    var checked = null;
                    for(var x = 0 ; x<ans.length ; x++){
                        if(ans[x].isChecked==true){
                            checked=ans[x].value;
                        }
                    }
                    
                    return checked;
                    
                    
                }
                
            });
        
    }
    
}